import { useState, useEffect } from "react";
import moment from "moment";
import InputDate from "../../components/form/InputDate";
import Select from "../../components/form/select/Select";
import ModalDefault from "../../components/ModalDefault";
import api from "../../services/api";
import message from "../../services/message";
import axios from "axios";
import { Container } from "../../styles/layout";
import {
  IconAdd,
  IconArrow,
  IconDetails,
  IconEdit,
  IconFilter,
  IconRemove,
} from "../../components/layout/Svgs";

import {
  HeaderPonto,
  SectionFilterPonto,
  SectionTablePonto,
  SectionDetailsPonto,
  SectionRegisterPonto,
  ContainerPonto,
} from "./styles";
import ButtonDownload from "../../components/form/ButtonDownload/ButtonDownload";
import { ContainerModal, SectionModal } from "../../components/layout/styles";
import Input from "../../components/form/input/Input";


export default function TiposPagamentosListar() {

  const [load, setLoad] = useState(false);
  const [modal, setModal] = useState(false);

  const [tiposPagamento, setTiposPagamento] = useState([])
  const [newTipoPagamento, setNewTipoPagamento] = useState({
    tipoPagamentoId: null,
    tipo:'',
    deducao:'',
    status:'ativo'
  })

  useEffect(() => {
    getTiposPagamento()
  }, [])

  async function getTiposPagamento(){
    try{
      let response : any =  await api.get(`/tipo-pagamento`)
      setTiposPagamento(response.data)
    }catch(error:any){
      message.error(String(error?.response?.data?.message));
    }
  }

  async function resetTipoPagamento(){
    setNewTipoPagamento({
      tipoPagamentoId: null,
      tipo:'',
      deducao:'',
      status:'ativo'
    })

    setModal(!modal)
  }

  function handleOnChangeNewtipoPagamento(name: string, value: string) {
    if (value) {
      setNewTipoPagamento({ ...newTipoPagamento, [name]: value });
    } else {
      setNewTipoPagamento({ ...newTipoPagamento, [name]: ''});
    }
  }

  async function editarTipoPagamento(id?: any) {
    try{
      if(id){
        let response = await api.get(`/tipo-pagamento/${id}`)
        setNewTipoPagamento(response.data)
      }else{
        resetTipoPagamento()
      }
      
      setModal(true);
    } catch(error: any) {
      message.error(String(error?.response?.data?.message));
    }
  }

  async function saveTipoPagamento(e:any){
    try{
      e.preventDefault();
      let response : any
      if(newTipoPagamento.tipoPagamentoId){
        response = await api.put(`/tipo-pagamento/${newTipoPagamento.tipoPagamentoId}`,newTipoPagamento)
        message.success(`Tipo de Pagamento Editado com Sucesso.`)
      }else{
        response = await api.post(`/tipo-pagamento`, newTipoPagamento)
        message.success(`Tipo de Pagamento Criado com sucesso`)
      }
      await getTiposPagamento()
      resetTipoPagamento()
      setModal(!modal)
    }catch(error:any){
      message.error(String(error?.response?.data?.message));
    }
  }

  async function excluirTipoPagamento(id:number){
    try{
      let response : any = await api.delete(`/tipo-pagamento/${id}`)
      getTiposPagamento()

      message.success(`Tipo de Pagamento Excluido com Sucesso.`)
    
    }catch(error:any){
      message.error(String(error?.response?.data?.message));
    }
  }


  return (
    <Container>
      <HeaderPonto>
        <h1 className="titlePonto">Tipos de Pagamento</h1>
        <button
          style={{ margin: "0px", width: "100px", letterSpacing: "1px",verticalAlign:'middle' }}
          className="btn btn-primary"
          onClick={() => editarTipoPagamento()}
        > 
          Adicionar 
          <i className="fa-solid fa-plus"></i>
        </button>
      </HeaderPonto>

      <SectionTablePonto>
        <table className="default">
          <thead>
            <tr>
              <th>Tipo</th>
              <th>Dedução</th>
              <th>Editar</th>
              <th>Remover</th>
              
            </tr>
          </thead>

          <tbody>
            { tiposPagamento && tiposPagamento.length > 0 &&
                tiposPagamento.map((row:any, key:any) =>(
              
                  <tr key={key}>
          
                    <td>{row.tipo}</td>
                    <td>{row.deducao}</td>
                    <td>
                      <button
                        className="btn"
                        onClick={() => editarTipoPagamento(row.tipoPagamentoId)}
                      >
                        <IconEdit />
                      </button>
                    </td>
                    <td>
                      <button
                        className="btn"
                        onClick={() => excluirTipoPagamento(row.tipoPagamentoId)}
                      >
                        <IconRemove />
                      </button>
                    </td>
                  </tr>
                ))
              }
          </tbody>
        </table>
      </SectionTablePonto>
      <ModalDefault
        id="modalDefault"
        onClose={() => resetTipoPagamento()}
        visible={modal}
      >
        <ContainerModal>
          <SectionModal>
            <h1>Editar / Adicionar - Tipo de Pagamento</h1>
            <form onSubmit={saveTipoPagamento}>
              <div className="field">
                <h4>Tipo</h4>
                <div className="input">
                  <Input type="text" name="tipo" value={newTipoPagamento?.tipo} onChange={handleOnChangeNewtipoPagamento}/>
                </div>
              </div>

              <div className="field">
                <h4>Dedução (%)</h4>
                <div className="input">
                  <Input type="number" name="deducao" value={newTipoPagamento?.deducao} onChange={handleOnChangeNewtipoPagamento}/>
                </div>
              </div>

              <div className="actions">
                <button type="submit" className="btn btn-success">Salvar</button>
                <button type="button"  onClick={() => resetTipoPagamento()} className="btn btn-danger">Voltar</button>
              </div>
            </form>
          </SectionModal>
            <button
              className="buttonClosePreview"
              onClick={() => resetTipoPagamento()}
            >
              <IconRemove width="22px" height="22px" />
              Fechar modal
            </button>
          
        </ContainerModal>
      </ModalDefault>
    </Container>
  );
}
